import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import ResalesRequestService from '../../services/resales-request';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const ContactForm = () => {
  const [reports, setReports] = useState({data:[]});
  const [contacts, setContacts] = useState([]);
  const [formEdit, setFormEdit] = useState(false);
  const [formChanges, setFormChanges] = useState([]);
  const [wasModified, setWasModified] = useState(false);
  
  const [erroRequired, setErroRequired] = useState({campos:[],erro:false})

  const model = {
    contact_cellphone: "",
    contact_email: "",
    contact_job: "",
    contact_name: "",
    contact_phone: "",
    contact_birthdate: "",
  };

  useEffect(() => {
    let contacts = ResalesRequestService.getResaleContacts(localStorage.getItem('companyId'));
    contacts.then(data => {
      setReports(data);
    });
  }, []);

  useEffect(() => {
    setContacts(reports.data);
    let changes = reports.data.map(v=>{
      return {...v};
    });
    setFormChanges(changes);
  }, [reports,formEdit]);

  useEffect(()=>{
    setWasModified(verificarWasModified());
    
  },[formChanges,erroRequired]);

  const verificarWasModified = () => {
    let tamanho = formChanges.length>contacts.length?formChanges.length:contacts.length;
    var retorno = false;
    var setRetorno = r =>{retorno = r};
    for (let i = 0; i < tamanho; i++) {
      
      Object.keys(model).map((v,k) =>{
        var v1 = null, v2 = null;
        try {
          v1 = contacts[i][v]?contacts[i][v]:'';
        } catch (error) {
          v1 = v==='company_id'?localStorage.getItem('companyId'):'';
        }
        try {
          v2 = formChanges[i][v]?formChanges[i][v]:'';
        } catch (error) {
          v2 = v==='company_id'?localStorage.getItem('companyId'):'';
        }
        if(v2 !== v1){
          setRetorno(true);
        }
        return null;
      })
      if(retorno){
        break;
      }
    }
    return retorno;
  };

  const verificarRequired = (k,name) => {
    var retorno = false;
    erroRequired.campos.map(campo=>{
      if(campo.campo === name && campo.indice === k)
        retorno = true;
      return null;
    });
    return retorno;
  }

  const removerRequired = (k,name) => {
    erroRequired.campos.map((campo,i)=>{
      if(campo.campo === name && campo.indice === k)
        erroRequired.campos.splice(i, 1);
      return null;
    })
  }

  const verificarAlteracoes = (index,value,attributeName) => {
    removerRequired(index,attributeName);

    var changes = [...formChanges];
    changes[index][attributeName] = value;
    setFormChanges(changes);
  };

  const saveContacts = ()=>{
    while(erroRequired.campos.length) {
      erroRequired.campos.pop();
    }
    erroRequired.erro= false;

    // verificar required
    let camposObrigatorios = ['contact_name','contact_email'];
    let required = {...erroRequired};
    formChanges.map((contact,k)=>{
      camposObrigatorios.map(v=>{
        if(contact[v] === null || contact[v] === "" || contact[v] === 0){
          let obj = {indice:k,campo:v};
          required.campos.push(obj);
          required.erro = true;
        }
        return null;
      });
      return null;
    });
    setErroRequired(required);
    if(!required.erro){
      // caso required nao tenha erro
      let contacts_params = {
        insert:[],
        update:[],
        delete:[]
      };
      formChanges.map(contact=>{
        //verificar se contato nao esta vazio
        let vazio = true;
        Object.keys(model).map(k=>{
          if(contact[k]!=='')
            vazio = false;
          return null;
        });
        if(!vazio){
          // caso tenha campo com valores
          if(contact.id){
            // caso tenha id => ja existe na tabela
            /**
             * ver se os valores são os mesmos q esta no banco,
             * caso seja, não passa para o formulario de update
             */
            let iguais = true;
            let c2 = {id:contact.id};
            contacts.map(c=>{
              if(c.id === contact.id)
                Object.keys(model).map(k=>{
                  if(contact[k]!==c[k]){
                    iguais = false;
                    c2[k] = contact[k];
                  }
                  return null;
                });
              return null;
            });
            if(!iguais)
            contacts_params.update.push(c2);
          }else{
            contacts_params.insert.push(contact);
          }
        }
        return null;
      });
      // verificar se foi removido
      contacts.map(c1=>{
        /**
         * caso tenha um contato na tabela do banco q nao tenha na modificada
         * então e enviada como delete
         */
        let existe = false;
        formChanges.map(c2=>{
          if(c1.id === c2.id){
            existe = true;
          }
          return null;
        })
        if(!existe)
          contacts_params.delete.push(c1);
        return null;    
      });

      let save = ResalesRequestService.updateResaleContacts(
        localStorage.getItem('companyId'),
        { params: { ...contacts_params } }
      );
      save.then(data => {
        setReports(data);
        setFormEdit(false);
        setWasModified(false);
      });
    }
  };

  const getLista = () => {
    if(!formEdit){
      return contacts;
    } else {
      return formChanges;
    }
  };

  const getValue = (index,attributeName)=>{
    if(!formEdit){
      return contacts[index][attributeName]?contacts[index][attributeName]:'';
    } else {
      return formChanges[index][attributeName]?formChanges[index][attributeName]:'';
    }
  };

  const createCardForm = (k,contact) => {
    return(
      <Card className="m-2" id={'card-contact-'+k} key={'contact-'+k}>
        <Card.Body>
          <Row>
            <Col xs={4}>
              <Form.Group>
                <Form.Label>Nome:</Form.Label>
                <Form.Control
                  className={verificarRequired(k,'contact_name')?'border-danger':''}
                  as="input"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoes(k,e.target.value,'contact_name')}
                  value={getValue(k,'contact_name')}
                  >
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={4}>
              <Form.Group>
                <Form.Label>Email:</Form.Label>
                <Form.Control
                  className={verificarRequired(k,'contact_email')?'border-danger':''}
                  as="input"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoes(k,e.target.value,'contact_email')}
                  value={getValue(k,'contact_email')}
                  >
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={4}>
              <Form.Group>
                <Form.Label>Perfil:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoes(k,e.target.value,'contact_job')}
                  value={getValue(k,'contact_job')}
                  >
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={4}>
              <Form.Group>
                <Form.Label>Telefone:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoes(k,e.target.value,'contact_phone')}
                  value={getValue(k,'contact_phone')}
                  >
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={4}>
              <Form.Group>
                <Form.Label>Celular:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={!formEdit}
                  onChange={e=>verificarAlteracoes(k,e.target.value,'contact_cellphone')}
                  value={getValue(k,'contact_cellphone')}
                  >
                </Form.Control>
              </Form.Group>
            </Col>
            <Col xs={4}>
              <Form.Group>
                <Form.Label>Data de Nascimento:</Form.Label>
                <DatePicker disabled={!formEdit}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  onChange={date=>verificarAlteracoes(k,new Date(date),'contact_birthdate')}
                  selected={getValue(k,'contact_birthdate') ? new Date(getValue(k,'contact_birthdate')):''}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
            {formEdit?(
                  <Button style={{marginRight:"5px"}}
                    variant="danger"
                    onClick={()=>{
                      let change = [...formChanges];
                      if(change[k].id !== null){
                        setWasModified(true);
                      } else {

                      }
                      change.splice(k, 1);
                      setFormChanges(change);
                    }}>Remover</Button>
                ):(<></>)}
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };
  
return (
<>
  <Card>
    <Card.Body>
      <Container>
        <Row className="mb-4">
          <Col>
            <p className="font-weight-bold">Contatos</p>
          </Col>
          <Col className="d-flex justify-content-end">
            {formEdit?(
            <>
              <Button style={{marginRight:"5px"}}
              size="sm"
                variant="success"
                disabled={!wasModified}
                title={!wasModified?'Não houve alterações':''}
                onClick={()=>{
                  saveContacts();
                }}>Salvar</Button>
              <Button style={{marginRight:"5px"}}
              size="sm"
                variant="danger"
                onClick={()=>{
                  setFormEdit(false);
                  setWasModified(false);
                  setFormChanges({...contacts})
                  setErroRequired({campos:[],erro:false})
                }}>Cancelar</Button>
            </>
            ):(<></>)}
            <Button
            size="sm"
              disabled={formEdit}
              onClick={()=>{
              setFormEdit(true);
            }}>{formEdit?'Editando':'Editar'}</Button>
          </Col>
        </Row>
        <Row className="m-2">
          <Col className="d-flex">
          {formEdit?(
                <Button style={{marginRight:"5px"}}
                  variant="secondary"
                  onClick={()=>{
                    let change = [...formChanges];
                    change.push({...model});
                    setFormChanges(change);
                    setTimeout(()=>{
                      var e = document.getElementById('card-contact-'+(change.length-1));
                      if(e)e.focus();
                      var offset = el => {
                        var rect = el.getBoundingClientRect(),
                        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
                      }
                      var divOffset = offset(e);
                      window.scrollTo(0, divOffset.top);
                      
                    }, 100);
                  }}>Adicionar Contato</Button>
              ):(<></>)}
          </Col>
        </Row>
        <Row>
          <Col>
            {getLista().map((c,k) =>{
              return (<>
                {createCardForm(k,c)}
                </>);
            })}
          </Col>
        </Row>
      </Container>
    </Card.Body>
  </Card>
</>
);
};

export default ContactForm;